module.exports = __webpack_public_path__ + "static/media/Adding_New_Account.35040b4e.mp4";